export const buttonFilterStyles = {
    marginRight: '4px',
    cursor: 'pointer',
};
